// extracted by mini-css-extract-plugin
export default {"copyButtonContainer":"copyButton_copyButtonContainer__1NdDR","input":"copyButton_input__YkN5M"};